export const clientInfoEsLocale = {
  'checkout.clientInfo.title': 'Información del cliente',
  'checkout.clientInfo.name': 'Nombre',
  'checkout.clientInfo.lastName': 'Apellido',
  'checkout.clientInfo.email': 'Correo electrónico',

  'checkout.clientInfo.nameError': 'Ingresa el nombre del cliente',
  'checkout.clientInfo.LastNameError': 'Ingresa el apellido del cliente',
  'checkout.clientInfo.emailError': 'Ingresa un correo electrónico válido',
  'checkout.clientInfo.identityDocument': 'Documento de identidad',
  'checkout.clientInfo.phone': 'Teléfono',

  'checkout.clientInfo.next': 'Siguiente',
} as const;

export const clientInfoEnLocale = {
  'checkout.clientInfo.title': 'Client information',
  'checkout.clientInfo.name': 'Name',
  'checkout.clientInfo.lastName': 'Last name',
  'checkout.clientInfo.email': 'Email',

  'checkout.clientInfo.nameError': 'Enter the customer name',
  'checkout.clientInfo.LastNameError': 'Enter the customer last name',
  'checkout.clientInfo.emailError': 'Enter a valid email',
  'checkout.clientInfo.identityDocument': 'Identity document',
  'checkout.clientInfo.phone': 'Phone',

  'checkout.clientInfo.next': 'Next',
} as const;
